<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-01 09:43:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-19 16:28:41
 * @FilePath: \minipro-manger\src\views\WeatherAlert\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE   
-->
<template>
  <div>
    <el-card class="box-card" style="height:850px">
      <div slot="header">
        <div class="headerCardBox">
          <div style="width:300px">
            <el-input placeholder="请输入内容" v-model="input1">
              <template slot="prepend">标题：</template>
            </el-input>
          </div>
          <div style="width:300px">
            <el-input placeholder="请输入内容" v-model="input1">
              <template slot="prepend">区域：</template>
            </el-input>
          </div>

          <div style="margin-left:50px;width:100px">发布时间：</div>
          <div style="width:600px;  display: flex;">
            <el-date-picker
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <div style="width:300px">
            <el-input placeholder="请输入内容" v-model="input1">
              <template slot="prepend">状态：</template>
            </el-input>
          </div>
        </div>
        <div class="seachBtn">
          <el-button type="primary">搜索</el-button>
          <el-button type="primary">重置</el-button>
        </div>
      </div>
      <div>
        <div class="adddBtnBox">
          <el-button>添加</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" border="true" height="600">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="date" label="标题" width="180"></el-table-column>

          <el-table-column prop="address" label="区域"></el-table-column>

          <el-table-column prop="address" label="创建时间"></el-table-column>
          <el-table-column prop="address" label="审核时间"></el-table-column>
          <el-table-column prop="address" label="状态"></el-table-column>
          <el-table-column prop="address" label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination> -->
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input1: "",
      tableData: []
    };
  }
};
</script>

<style>
.headerCardBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.seachBtn {
  display: flex;
  justify-content: end;
  margin-top: 15px;
}
.adddBtnBox {
  height: 50px;
  float: right;
}
</style>